'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sendRequestQuotePurchaseNotification = exports.sendRequestProductActivationNotification = exports.sendRequestTrialNotification = exports.sendRequestSKUNotification = exports.sendRequestAdditionalSeatsNotification = exports.sendRequestAccessNotification = undefined;

var _apiClient = require('hub-http/clients/apiClient');

var _apiClient2 = _interopRequireDefault(_apiClient);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var sendRequestAccessNotification = exports.sendRequestAccessNotification = function sendRequestAccessNotification(productName) {
  return _apiClient2.default.post('self-service/v2/request-access', { data: { productName: productName } });
};

var sendRequestAdditionalSeatsNotification = exports.sendRequestAdditionalSeatsNotification = function sendRequestAdditionalSeatsNotification(productName) {
  return _apiClient2.default.post('self-service/v2/request-additional-seats', {
    data: { productName: productName }
  });
};

var sendRequestSKUNotification = exports.sendRequestSKUNotification = function sendRequestSKUNotification(productName, cta) {
  return _apiClient2.default.post('self-service/v2/request-sku', { data: { productName: productName, cta: cta } });
};

var sendRequestTrialNotification = exports.sendRequestTrialNotification = function sendRequestTrialNotification(productName, cta) {
  return _apiClient2.default.post('self-service/v2/request-trial', {
    data: { productName: productName, cta: cta }
  });
};

var sendRequestProductActivationNotification = exports.sendRequestProductActivationNotification = function sendRequestProductActivationNotification(productName, cta) {
  return _apiClient2.default.post('self-service/v2/request-product', {
    data: { productName: productName, cta: cta }
  });
};

var sendRequestQuotePurchaseNotification = exports.sendRequestQuotePurchaseNotification = function sendRequestQuotePurchaseNotification(cta) {
  return _apiClient2.default.post('self-service/v2/request-quote-purchase', {
    data: { cta: cta }
  });
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.1086/js/_core/common/api/requestNotificationsApi.js
// module id = 98
// module chunks = 3 4 5